export const AI_COVER_TEMPLATE_SLUG = 'ai_photo_book_cover'
export const RIVIERA_COVER_TEMPLATE_SLUG = 'ai_photo_book_cover_riviera'
export const SKETCH_COVER_TEMPLATE_SLUG = 'ai_photo_book_cover_sketch'
export const PHOTO_BOOK_COVER_PRODUCT_FLOW = 'PHOTO_BOOK_COVER'
